<div class="relative">
  <div class="container w-[260px]  min-w-full">
    <div class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] pb-2">
      <div class="flex items-center gap-3 w-full">
        <div>
          <tui-svg src="tuiIconUsersLarge" style="color: black;"></tui-svg>
        </div>
        <div>
          <h3 class="flex items-center text-black text-[1.5rem] font-bold">Members</h3>
        </div>
      </div>
      <div class="flex gap-2 mt-3 sm:mt-0">
        <div class="">
          <button tuiButton appearance="" (click)="toggle()" class="">
            <div class="flex justify-center items-center btn-outline w-[80px] sm:w-[160px]">
              <tui-svg src="tuiIconSlidersLarge" class="sm:pt-3 rotate-90 flex items-center"
                style="color: #bb0021;"></tui-svg>
              <p class="hidden sm:block">Advanced Search</p>
            </div>
          </button>
        </div>
        <div class="">
          <button tuiButton appearance="" class="" (click)="navigateToAdd()">
            <div class="flex justify-center items-center w-[180px] sm:w-[160px] btn-outline">
              <p class="flex justify-center items-center text-[13px] h-[24px]">Add New Member</p>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="mt-2 sm:mt-0">
      <div class=" flex flex-col lg:flex-row justify-between" *ngIf="showSearch">
        <div class="flex sm:items-center gap-1 flex-col sm:flex-row">
          <div class="w-full sm:w-60">
            <tui-input tuiTextfieldIconLeft="tuiIconSearchLarge" [tuiTextfieldCleaner]="true" tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true" [style.text-align]="'left'" class="" [(ngModel)]="searchText"
              (tuiValueChanges)="cancelSearch($event)">
              Search
              <input autocomplete="fname" tuiTextfield type="text" />
            </tui-input>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-40 py-3">
            <tui-select [(ngModel)]="paymentStatus" tuiTextfieldSize="m" [tuiTextfieldLabelOutside]="true"
              [style.text-align]="'left'" class="">
              Payment Status
              <input tuiTextfield type="text" />
              <tui-data-list-wrapper *tuiDataList [items]="paymentitems">
              </tui-data-list-wrapper>
            </tui-select>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-40 py-3">
            <tui-select [(ngModel)]="memberStatus" (ngModelChange)="statusChange()" tuiTextfieldSize="m"
              [tuiTextfieldLabelOutside]="true" [style.text-align]="'left'" class="">
              Active Status
              <input tuiTextfield type="text" />
              <tui-data-list-wrapper *tuiDataList [items]="statusitems">
              </tui-data-list-wrapper>
            </tui-select>
          </div>
          <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
          <div class="w-full sm:w-[100px] my-3">
            <button tuiButton tuiTextfieldSize="s" type="button" class="w-full" (click)="search()">
              <tui-svg src="tuiIconSearchLarge" class="pr-2 text-white"></tui-svg>
              <span class="text-white">Search</span>
            </button>
          </div>

        </div>
        <!--            <div class="text-[#FFFFFFB8] flex gap-1 items-center justify-end">-->
        <!--                <label>-->
        <!--                    Active-->
        <!--                    <tui-toggle-->
        <!--                        size="l"-->
        <!--                        class=""-->
        <!--                    ></tui-toggle>-->
        <!--                </label>-->
        <!--            </div>-->
      </div>
    </div>
    <div class="flex justify-between p-2 pr-5 bg-[#faf0f2] rounded mt-2  w-full" *ngIf="statusMsg">
      <div class="flex items-center">
        <img src="/assets/img/resulticon.png" alt="">
        <p class="text-black pl-2">{{showText()}}</p>
      </div>
      <div>
        <button class="text-[#bb0021] hover:scale-110 transition-all duration-100" (click)="resetStatus()">Reset
        </button>
      </div>
    </div>
    <tui-loader [overlay]="true" [showLoader]="isLoading" class="mt-3">
      <div *ngIf="memberData.length > 0" class="overflow-x-scroll" style="white-space: nowrap">
        <table class="tui-table w-full">
          <thead tuiThead class="">
            <tr class="tui-table__tr">
              <th class="tui-table__th">Club ID</th>
              <th class="tui-table__th">Full Name</th>
              <!-- <th class="tui-table__th">Date Of Birth</th> -->
              <!-- <th class="tui-table__th">Gender</th> -->
              <th class="tui-table__th">Mobile Number</th>
              <th class="tui-table__th">Email Address</th>
              <!-- <th class="tui-table__th">Emergency Contact Name</th>
            <th class="tui-table__th">Emergency Contact Number</th> -->
              <!-- <th colspan="2" class="tui-table__th">
              <div class="flex flex-col mt-5">
                <div class="flex items-center justify-center">Emergency Contact details</div>
                <div class="grid grid-cols-2">
                  <div class="">Name</div>
                  <div class="">Mobile Number</div>
                </div>
              </div>
            </th> -->
              <!-- <th class="tui-table__th">Address</th> -->
              <th class="tui-table__th">
                <div class="flex">
                  <span>Member Since</span>
                  <tui-svg class=" nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronUp" (click)="toggleSortMemberDate()" *ngIf="sortMemberDate === -1"></tui-svg>

                  <tui-svg class=" nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronDown" (click)="toggleSortMemberDate()" *ngIf="sortMemberDate === 1"></tui-svg>
                </div>
              </th>
              <th class="tui-table__th">Program</th>
              <th class="tui-table__th">Session Type</th>
              <th class="tui-table__th">Payment Status</th>
              <th class="tui-table__th">Active Status</th>
              <!--            <th class="tui-table__th">Active Date</th>-->
              <th class="tui-table__th">
                <div class="flex">
                  <span>Created Date</span>
                  <tui-svg class=" nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronUp" (click)="toggleSortDate()" *ngIf="sortDate === -1"></tui-svg>

                  <tui-svg class=" nav-icon group-hover:text-accent ml-2 mr-1 p-1 w-2 h-2 cursor-pointer"
                    src="tuiIconChevronDown" (click)="toggleSortDate()" *ngIf="sortDate === 1"></tui-svg>
                </div>
              </th>
              <th class="tui-table__th" style="width:100px;">Actions</th>
            </tr>
          </thead>
          <tbody class="">
            <tr class="tui-table__tr" *ngFor="let data of memberData; let i = index">
              <td class="tui-table__td">{{ data.membershipId }}</td>
              <td class="tui-table__td no-underline hover:underline" style="color: #bb0021;cursor: pointer"
                (click)="navigateToSingle(data)">{{ data.firstname }} {{ data.lastname }}</td>
              <!-- <td class="tui-table__td">{{ formatDate(data.dob) }}</td>
            <td class="tui-table__td" *ngIf="data.gender === 'MALE'">Male</td>
            <td class="tui-table__td" *ngIf="data.gender === 'FEMALE'">Female</td>
            <td class="tui-table__td" *ngIf="data.gender === 'OTHER'">Other</td> -->

              <!-- <td class="tui-table__td">{{ data.mobileNo }}</td>
            <td class="tui-table__td">{{ data.email }}</td> -->

              <td class="tui-table__td">
                <a *ngIf="data.mobileNo" href="tel:{{ data.mobileNo }}">{{ data.mobileNo }}</a>
                <span *ngIf="!data.mobileNo">-</span>
              </td>
              <td class="tui-table__td">
                <a *ngIf="data.email" href="mailto:{{ data.email }}">{{ data.email }}</a>
                <span *ngIf="!data.email">-</span>
              </td>

              <!-- <td class="tui-table__td">{{ data.emergencyContact?.name }}</td>
            <td class="tui-table__td">{{ data.emergencyContact?.mobileNo }}</td>
            <td class="tui-table__td">{{ data.address }}</td> -->

              <td class="tui-table__td">{{ formatDate(data.registrationDate) }}</td>
              <td class="tui-table__td">
                <tui-select [(ngModel)]="data.programs" (ngModelChange)="savePrograms(data)" multiple class="w-[150px]">
                  <div class="flex items-center gap-1">
                    <span *ngIf="data.programs && data.programs.length > 0">
                      Select Program
                    </span>
                    <span *ngIf="!data.programs || data.programs.length === 0">-</span>
                  </div>
                  <input tuiTextfield type="text" />
                  <tui-data-list-wrapper *tuiDataList [items]="allPrograms"></tui-data-list-wrapper>
                </tui-select>
              </td>
              <td class="tui-table__td">
                <tui-select [(ngModel)]="data.session" (ngModelChange)="onSessionChange($event, data)" class="w-full">
                  <tui-data-list-wrapper *tuiDataList [items]="sessions"></tui-data-list-wrapper>
                  Select Session
                </tui-select>
              </td>
              <td class="tui-table__td" *ngIf="!data.programs || data.programs.length === 0">-</td>
              <td class="tui-table__td">
                <div class="flex items-center gap-1" *ngIf="data.paymentStatus?.type === 'Paid'">
                  <div class="w-[10px] h-[10px] rounded-full bg-[#4AC99B]"></div>
                  Paid
                </div>
                <div class="flex items-center gap-1" *ngIf="data.paymentStatus?.type === 'Not Paid'">
                  <div class="w-[10px] h-[10px] rounded-full bg-[#FF4646]"></div>
                  Not Paid
                </div>
              </td>
              <td class="tui-table__td">
                <div class="flex items-center gap-1" *ngIf="data.isActive">
                  <div class="w-[10px] h-[10px] rounded-full bg-[#4AC99B]"></div>
                  Active
                </div>
                <div class="flex items-center gap-1" *ngIf="!data.isActive">
                  <div class="w-[10px] h-[10px] rounded-full bg-[#FF4646]"></div>
                  Inactive
                </div>
              </td>

              <!--            <td class="tui-table__td">To DO</td>-->
              <td class="tui-table__td">{{ formatDate(data.createdAt) }}</td>
              <td class="tui-table__td">
                <div class="flex items-center justify-between" style="width:100px;">
                  <a class="text-[#bb0021] hover:scale-110 transition-all duration-100" style="cursor: pointer"
                    (click)="navigateToUpdate(data)">Edit</a>
                  <button [tuiDropdown]="dropdownContent" [tuiDropdownManual]="openStates[i]" (click)="onClick(i)"
                    (tuiActiveZoneChange)="onActiveZone($event)" (tuiObscured)="onObscured($event)">
                    <tui-svg src="tuiIconMoreVertical" class="hover:scale-110 transition-all duration-100"></tui-svg>
                    <ng-template #dropdownContent>
                      <div class="dropdown dropdownContent" (click)="navigateToSingle(data)">View
                      </div>
                      <div class="dropdown dropdownContent" (click)="viewPaymentAdd(data)">Add Payments
                      </div>
                      <div class="dropdown dropdownContent" (click)="onStatusChange(data)">Change Status
                      </div>
                      <div class="dropdown dropdownContent" style="color: red" (click)="onDelete(data._id,data.email)">
                        Delete
                      </div>
                    </ng-template>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="memberData.length === 0 && !isLoading" class="mt-3">
        <p class="text-[#D8D8D8] text-center">No Data</p>
      </div>
    </tui-loader>
    <div class="text-black py-10 flex justify-end w-full max-w-full">
      <tui-pagination [index]="pageSize.pageIndex-1" [length]="pageSize.length" (indexChange)="goToPage($event)"
        class="text-black">
      </tui-pagination>
    </div>
  </div>
</div>